export const faqs = [
  {
    id: 'faq-1',
    question: '东升大舞台App在哪里可以下载？',
    answer: '您可以通过本网站提供的官方下载入口获取东升大舞台App。安卓用户可直接下载APK安装包进行安装，iOS用户可通过官方提供的TestFlight链接或App Store搜索"东升大舞台"进行下载。请务必通过官方渠道下载，以确保账号安全和最佳使用体验。',
  },
  {
    id: 'faq-2',
    question: '东升大舞台App支持哪些手机系统？',
    answer: '东升大舞台App目前支持Android 8.0及以上版本的安卓设备，以及iOS 14.0及以上版本的苹果设备。我们持续优化适配，以确保在主流设备上都能流畅运行。建议您将手机系统更新至最新版本以获得最佳体验。',
  },
  {
    id: 'faq-3',
    question: '如何注册东升大舞台账号？',
    answer: '打开东升大舞台App后，点击"注册"按钮，您可以选择使用手机号码注册或微信一键登录。使用手机号注册时，需要输入手机号码获取验证码，设置登录密码并填写基本个人信息即可完成注册。整个过程大约只需1分钟。',
  },
  {
    id: 'faq-4',
    question: '忘记登录密码怎么办？',
    answer: '如果您忘记了东升大舞台的登录密码，可以在登录页面点击"忘记密码"，通过绑定的手机号码接收验证码来重置密码。请确保您使用的手机号码与注册时一致。如遇到任何问题，也可以联系我们的客服团队获取帮助。',
  },
  {
    id: 'faq-5',
    question: '东升大舞台App收费吗？',
    answer: '东升大舞台App下载和基础功能完全免费。部分精彩演艺内容可能需要付费观看或订阅会员服务。我们提供多种会员方案供您选择，具体价格请在App内查看。新用户首次注册还可享受专属优惠福利。',
  },
  {
    id: 'faq-6',
    question: '下载安装后App无法打开怎么办？',
    answer: '如果遇到App无法打开的情况，请尝试以下步骤：1）检查手机存储空间是否充足；2）确认手机系统版本是否满足最低要求；3）尝试卸载后重新下载安装；4）清理手机缓存后重启设备。如果问题仍未解决，请联系客服并提供您的手机型号和系统版本信息。',
  },
  {
    id: 'faq-7',
    question: '可以在多台设备上同时登录同一个账号吗？',
    answer: '出于账号安全考虑，东升大舞台App目前仅支持单设备登录。当您在新设备上登录时，原设备上的登录状态会自动退出。我们建议您在个人常用设备上使用App，避免频繁切换设备以保障账号安全。',
  },
  {
    id: 'faq-8',
    question: '如何联系东升大舞台客服？',
    answer: '您可以通过以下方式联系我们：1）App内"我的"-"联系客服"入口在线咨询；2）发送邮件至官方客服邮箱 kefu@dongshengdawutai.com；3）拨打客服热线 400-000-0000（工作日9:00-18:00）。我们的客服团队会尽快为您解决问题。',
  },
  {
    id: 'faq-9',
    question: '东升大舞台App的隐私安全如何保障？',
    answer: '东升大舞台高度重视用户隐私和数据安全。我们采用行业标准的加密技术保护您的个人信息，严格遵守相关法律法规。您的账号密码、支付信息等敏感数据均经过加密处理，不会泄露给任何第三方。详细内容请查阅App内的《隐私政策》。',
  },
  {
    id: 'faq-10',
    question: '如何取消东升大舞台会员自动续费？',
    answer: '您可以在东升大舞台App内"我的"-"会员中心"-"管理订阅"中取消自动续费。安卓用户也可以通过Google Play订阅管理取消，iOS用户可在iPhone"设置"-"Apple ID"-"订阅"中管理。取消后当前会员周期仍可使用至到期日。',
  },
];